import { render, staticRenderFns } from "./SystemNavItemEdit.vue?vue&type=template&id=1b46aa24&scoped=true"
import script from "./SystemNavItemEdit.vue?vue&type=script&lang=js"
export * from "./SystemNavItemEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b46aa24",
  null
  
)

export default component.exports